// extracted by mini-css-extract-plugin
module.exports = {"calender_table":"calendarTable_calender_table__3oMa_","supplement":"calendarTable_supplement__1fw9L"};